import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tabu",
  "description": "",
  "published": "2007-03-12T00:00:00.000Z",
  "redirect_from": ["/blog/tabu/swizec/264"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vceraj se je moj spomin spotaknil in pomislil na Tabujevce in kako sem jih svoje case z veseljem poslusal. Seveda sem se takoj spomnil na youtube in bil grozno razocaran nad dejstvom, da ni bilo nic za najti. Zatorej sem se, kot vsaka odgovorna odrasla oseba, odpravil na njihovo stran, pokradel vse videe, ki jih nudijo, in jih nemudoma spravil na youtube. Upam, da jih ne moti zastonj publiciteta.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=t6gwncRfmhE"
        }}>{`Lahko Sem Srce`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=1YZ97JIW49Y"
        }}>{`Angel`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=c2PbpxD6Z2o"
        }}>{`Divje`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=wRQzf_hvqR8"
        }}>{`Tabu`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=c0t1qG19azQ"
        }}>{`V soju luci`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      